module.exports = __webpack_public_path__ + "img/Akvifar_skarm2.aa8e11cb.jpg";